<template>
  <div>
    <div class="mb-10">
      <v-date-picker
        v-model="date"
        type="month"
        locale="pl"
        @click.native="selectDate(date)"
      ></v-date-picker>
    </div>


    <v-btn class="mb-5" depressed color="primary" @click="downloadReportXls">
      <v-icon class="mr-4">mdi-download</v-icon>
      Pobierz raport XLS
    </v-btn>
    <h2>Filmy</h2>
    <StatisticTable :data="dataMovies" />
    <h2>Artykuły</h2>
    <ArticleStatisticTable :data="dataArticles" />
  </div>
</template>

<script>
import axiosConf from "../../axios-conf";
import FileSaver from "file-saver";
import StatisticTable from "@/components/StatisticTable.vue";
import ArticleStatisticTable from "../../components/ArticleStatisticTable.vue";

export default {
  components: {
    ArticleStatisticTable,
    StatisticTable
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 7),
      dataMovies: [],
      dataArticles: []
    };
  },
  methods: {
    selectDate(date) {
      this.getData(date);
    },
    downloadReportXls(e) {
      e.preventDefault();
      axiosConf
        .get(`movie/statistics/${this.date}.xlsx`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          },
          responseType: 'arraybuffer',
        })
        .then(response => {
          window.console.log(response);
          // const BOM = "\uFEFF";
          const fileData = (response.data);
          const blob = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
          FileSaver.saveAs(blob, `statystyki-${this.date}.xlsx`);
        });
    },

    async getData(date) {
      const responseMove = await axiosConf
        .get(`movie/statistics/${date}.json`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
      this.dataMovies = [...responseMove.data.statistics];
      const responseArticle = await axiosConf
        .get(`article/statistics/${date}.json`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
      this.dataArticles = [...responseArticle.data.statistics];

    }
  },
  mounted() {
    let today = new Date();
    let mm = String(today.getMonth()+1).padStart(2, '0');
    let yyyy = today.getFullYear();
    this.getData(`${yyyy}-${mm}`);
  }
};
</script>
